module.exports = __webpack_public_path__ + "img/verify.0a27e09f.svg";